import { useEffect, useState } from "react";
import ClientAction from "../../Clientaction/Clientaction";
import { MessageService } from "../../../services";
import "./style.css";
import { decodeJWT } from "../../../utils/commonFns";
import "./style.css";
import Toaster from "../../Toaster/Toster";


interface CommunicationsProps {
    formData: any;
    report: any;
    setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const Communications: React.FC<CommunicationsProps> = ({
    formData,
    report,
    setFormData,
}) => {
    const [activities, setActivities] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState<string>("");
    const [showToster, setShowToster] = useState<boolean>(false);
    const [tosterInfo, setTosterInfo] = useState<{ type: "success" | "error" | "warning", message: string }>({ type: "success", message: "" });

    const fetchMessages = async (id: string) => {
        await MessageService.getReportMessage(id)
            .then(response => {
                setActivities(response.messages || []);
            })
            .catch(error => {
                console.log('Error fetching car messages:', error);
            })
    };

    useEffect(() => {
        fetchMessages(report.id)
    }, [])

    const handleSubmitMessage = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        const token = localStorage.getItem('access_token');
        if (!token) {
            setTosterInfo({ type: "error", message: `Auth Token not found.` });
            setShowToster(true);
            return;
        }

        const decodedToken = decodeJWT(token);
        console.log(decodedToken)

        const senderContact = decodedToken.salesforceId;

        const messagePayload = {
            messageBody: message,
            senderContact: senderContact,
            summaryReportId: report.id,
            recipientUser: "",
            logoRequest: "",
            projectId: report?.Project__c,
        };

        await MessageService.addCarMessage(messagePayload)
            .then(response => {
                fetchMessages(report.id);
                setIsLoading(false);
                setTosterInfo({ type: "success", message: `Message was sent successfully.` })
                setShowToster(true);
                setMessage("")
            })
            .catch(error => {
                setIsLoading(false);
                setTosterInfo({ type: "error", message: `Message was not sent, Please try after some time.` });
                setShowToster(true);
                setMessage("")
            });
    }
    return (
        <div className="p-4">
            <ClientAction
                activities={activities}
                isLoading={isLoading}
                message={message}
                setmessage={setMessage}
                handleSubmitMessage={handleSubmitMessage}
                sidebyside={true} />
            <Toaster
                type={tosterInfo.type}
                show={showToster}
                setShow={setShowToster}
                message={tosterInfo.message}
            />
        </div>
    )
}

export default Communications